import React from "react";

const CopyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.333"
      height="20"
      viewBox="0 0 17.333 20"
    >
      <g id="Layer_2" data-name="Layer 2" transform="translate(-3 -1)">
        <path
          id="Path_1210"
          data-name="Path 1210"
          d="M5.547,18.333h.12v.12A2.547,2.547,0,0,0,8.213,21h9.573a2.547,2.547,0,0,0,2.547-2.547V6.213a2.547,2.547,0,0,0-2.547-2.547h-.12v-.12A2.547,2.547,0,0,0,15.12,1H5.547A2.547,2.547,0,0,0,3,3.547v12.24A2.547,2.547,0,0,0,5.547,18.333ZM17.787,5A1.22,1.22,0,0,1,19,6.213v12.24a1.22,1.22,0,0,1-1.213,1.213H8.213A1.22,1.22,0,0,1,7,18.453V6.213A1.22,1.22,0,0,1,8.213,5Z"
        />
      </g>
    </svg>
  );
};

export default CopyIcon;
